module.exports = __webpack_public_path__ + "img/logo_original.763d9fba.png";